/**
 * Created by idea on 03/07/2017.
 */
import {Component} from '@angular/core';

declare var jQuery:any;

@Component({
    selector: 'basic',
    templateUrl: 'basic.template.html'
})

export class basicComponent {
    constructor(){
    }

}


// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/layouts/basic.component.ts